import { app_psnl_menu_template_hdr_RowClass, app_psnl_menu_template_hdr_RowInterface } from "../../dbschema/app_psnl_menu_template_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class PersonalMenuTemplateHdrContainer extends BaseContainerModel {
  app_psnl_menu_template_hdr: app_psnl_menu_template_hdr_RowInterface = new app_psnl_menu_template_hdr_RowClass();
}